import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux'
import * as act from "./Store/actions"
import {
    withRouter
} from "react-router-dom";
import { application, State } from './State'
const merge = require('deepmerge')
const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray

const mapStateToProps = (state) => {
    return {
        application: state.application,
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateChangeApplication: (application) => {
        dispatch(act.updateApplication(application))
    },
});


// The loan officer's "Borrower application" in the LOS opens this page in an
// iframe with a one-time ticket in the fragment (#ticket=...). The ticket,
// not the customer and loan in the address, is what signs in as the loan's
// borrower; see web/go/src/borrower_view_for_loan_officer.go.
const takeTicketFromAddress = () => {
    const ticket = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("ticket") || ""
    if (window.location.hash) {
        window.history.replaceState(null, "", window.location.pathname + window.location.search)
    }
    return ticket
}

export default function BorrowerInterviewForLO(props) {   
     
    const customerid = props.match.params["customerid"];
    const loanid = props.match.params["loanid"];
    const started = useRef(false)
    const [failed, setFailed] = useState(false)
    
    const signin = () => {
        const ticket = takeTicketFromAddress()
        if (!ticket) {
            setFailed(true)
            return
        }

        let tosend = JSON.stringify({
                Ticket: ticket,
                CustomerID: customerid,
                LoanID: loanid,
            })
            
        fetch('/borrower/borrowerviewforlogetstate', {
            method: 'POST',
            body: tosend,
            headers: { 'Content-Type': 'application/json' },
        }).then(
            response => {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' +
                        response.status);
                    setFailed(true)
                    return;
                }
                response.json().then(js => {
                    if (js.Status !== "OK") {
                        console.log("Error: " + js.Text)
                        sessionStorage.setItem("edit", "false")
                        sessionStorage.setItem("state", "{}");
                        sessionStorage.setItem("originalstate", "{}");
                        setFailed(true)
                        return
                    } else {
                        sessionStorage.setItem("ZeitroA", js.Token)
                        let state = JSON.parse(js.State)

                        let serstate
                        if ("{}" === js.State) {
                            state = JSON.parse((() => { let l = new State(); return l.toJson() })())
                        }
                        try {
                            let applicationInitialState = JSON.parse((() => { let l = new application(); return l.toJson() })())
                            let app = merge(applicationInitialState, state.application, { arrayMerge: overwriteMerge })
                            state.application = app
                        } catch (x) {
                            // just keep it
                        }
                        sessionStorage.removeItem("state")
                        sessionStorage.removeItem("originalstate")
                        serstate = JSON.stringify(state)
                        sessionStorage.setItem("state", serstate)
                        sessionStorage.setItem("originalstate", serstate)
                        props.updateChangeApplication({ ...state.application })
                        

                        redirectCustomer(js, state)
                    }
                });
            }
        ).catch((err) => {
            console.log('Fetch Error :', err);
            setFailed(true)
        });
    }

    const redirectCustomer = (js, state) => {

        const isHardMoneyLoan = state.application.product.mortgageapplied === "hardmoneyloan"
        sessionStorage.setItem("fromiframe", true)
        let path = ""

        if ("undefined" === typeof state.progress || "undefined" === typeof state.progress.stage || 
        "undefined" === typeof state.application.property.purpose || 
        state.application.property.purpose === null) {
            path = "/services/preapp?customerid=" + customerid
        } else {

            path = "/application/v2/interview/continue?fromiframe=true"

        }

        if (isHardMoneyLoan) path = "/application/hardMoneyLoan/interview/main/borrower?fromiframe=true"

        window.location.href = path
    }


    useEffect(()=>{
        // Once: the ticket is good for one use.
        if (started.current) return
        started.current = true
        sessionStorage.setItem("edit", "false")
        sessionStorage.setItem("state", "{}");
        sessionStorage.setItem("originalstate", "{}");

        signin()
    }, [])

    if (failed) {
        return (
            <div style={{ padding: "40px 20px", textAlign: "center" }}>
                This page opens from the loan's "Borrower application" in the loan officer system. Open it again from there.
            </div>
        )
    }
    return (
        <div></div>
    )
}

BorrowerInterviewForLO = withRouter(connect(mapStateToProps, mapDispatchToProps)(BorrowerInterviewForLO))
